import React from 'react';
import Background from '../../images/Background.png';
import backgroundBlue from '../../images/background-blue.png';
import backgroundPink from '../../images/background-pink.png';
import backgroundGray from '../../images/background-gray.png';
import Skilllogo from '../../images/logos/skill.png';
import Servicelogo from '../../images/logos/service.png';
import Switch from '../../images/Switch.png';
import infoBlue from '../../images/info-blue.png'
import infoGray from '../../images/info-gray.png'
import infoPink from '../../images/info-pink.png'
import nolog_blue from '../../images/nolog_blue.png';
import nolog_pink from '../../images/nolog_pink.png';
import nolog_gray from '../../images/nolog_gray.png';
import StudentProfile from '../../components/StudentProfile';
import ProjectCard from '../../components/ProjectCard';
import ProjectInfoModal from './components/projectInfoModal.js';
import ProjectHeader from './components/projectHeader.js';
import Investigation from './components/investigation.js';
import Preparation from './components/preparation.js';
import Action from './components/action.js';
import Demonstration from './components/demonstration.js';
import Reflection from './components/reflection.js';
import UnavailablePopup from './components/unavailablePopup.js';
import { Layout, Menu, message, Col, Row, Icon, Button, Tooltip, Popover } from 'antd';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase'
import profileImage from '../../images/profileImage.png'
import * as R from 'ramda'
import { withRouter } from 'react-router'
import { translate } from 'react-i18next';
import PDFLayout from '../../components/PDFLayout/serviceTracker_student'
const { Header, Content } = Layout;
const  moment = require('moment');

class Service extends React.Component {

  state = {
    projects: [],
    projectInfoModal: false,
    editingProject: "",
    editingId: "",
    currentPhase: null,
    editingPhase: null,
    toExport: null,
    unavailablePopup: false
  }

  componentDidUpdate(prevProps) {

    if (this.props.profile && !this.state.color) {
      this.getTheme()
    }

  }

  deleteFile = (url, index, activityId) => {
    const { firebase, uid } = this.props
    const { editingId } = this.state
    const path = firebase.storage().refFromURL(url).location.path
    firebase.deleteFile(path)
    let downloadURL = this.props.projects[editingId].Action.actionObject[activityId].downloadURL
    downloadURL = downloadURL && downloadURL.filter( item=>
      item.url !== url
    )
    firebase.database().ref(`/projects/${uid}/${editingId}/Action/actionObject/${activityId}/downloadURL`).set(downloadURL)
  }

  getTheme = () => {
    let color;
    let background;
    const { theme_service } = this.props.profile.profile
    switch (theme_service) {
      case 'gray':
        color = '#7c868d'
        background = backgroundGray
        break;
      case 'pink':
        color = '#F190AC'
        background = backgroundPink
        break;
      case 'default':
        color = '#006588'
        background = backgroundBlue
        break;
      default:
        color = '#006588'
        background = backgroundBlue
    }
    if (color) {
      this.setState({color, background})
    } else {
      this.setState({color: '#107498'})
    }
  }

  changeTheme = (color) => {
    const { uid } = this.props.auth
    this.props.firebase.database().ref(`/users/${uid}/profile`).update({
      theme_service: color
    }).then( () => this.getTheme())
  }

  addProject = (title, description) => {
    const { firebase, uid } = this.props
    if (typeof this.state.projectInfoModal === 'object') { //Edit mode
      const { projectId } = this.state.projectInfoModal
      firebase.database().ref(`/projects/${uid}/${projectId}`).update({
        projectDescription: description,
        projectTitle: title
      })
      this.setState({projectInfoModal: false})
    } else { //New project mode
      const new_projectId = firebase.database().ref(`/projects/${uid}`).push().key
      let project = newProjectObj
      project.projectDescription = description
      project.projectTitle = title
      firebase.database().ref(`/projects/${uid}/${new_projectId}`).set(project)
      this.setState({
        projectInfoModal: false,
        editingId: new_projectId,
        editingProject: true,
        editingPhase: 1,
        currentPhase: 1
      })
    }
  }

  getNoLogImg = () => {
    if (this.state.color == '#006588') {
      return nolog_blue
    } else if (this.state.color == '#F190AC') {
      return nolog_pink
    } else {
      return nolog_gray
    }
  }

  editProject = (projectId) => {
    let currentPhase;
    const { uid, firebase } = this.props
    switch(this.props.projects[projectId].current_phase) {
      case 'Investigation':
        currentPhase = 1
        break;
      case 'Preparation':
        currentPhase = 2
        break;
      case 'Action':
        currentPhase = 3
        break;
      case 'Reflection':
        currentPhase = 4
        break;
      case 'Demonstration':
        currentPhase = 5
        break;
      default:
        currentPhase = 6
        break;
    }
    this.setState({
      editingId: projectId,
      editingProject: true,
      currentPhase,
      editingPhase: currentPhase == 6 ? 1 : currentPhase
    })
  }

  editProjectTitle = (projectId) => {
    const { uid, firebase, projects } = this.props
    if (projects[projectId].status == 'complete' || projects[projectId].status == 'completed') {
      firebase.database().ref(`/projects/${uid}/${projectId}`).update({
        current_phase: 'Demonstration',
        status: 'inprogress'
      })
        this.setState({
          editingId: projectId,
          editingProject: true,
          currentPhase: 5,
          editingPhase: 5
        })
    } else {
      const data = {
        projectDescription: this.props.projects[projectId].projectDescription,
        projectTitle: this.props.projects[projectId].projectTitle,
        projectId
      }
      this.setState({projectInfoModal: data})
    }
  }

  saveData = (data, submitting) => {
    const { uid, firebase, t } = this.props
    const { editingId } = this.state

    const removeEmpty = (obj) => {
      Object.keys(obj).forEach(key => {
        if (obj[key] && typeof obj[key] === 'object') removeEmpty(obj[key]);
        else if (obj[key] === undefined) delete obj[key];
      });
      return obj;
    };

    if (data.projectTitle) {
      firebase.database().ref(`/projects/${uid}/${editingId}`).update({projectTitle: data.projectTitle})
    }
    console.log('saving........', data, submitting)
    data = removeEmpty(data)
    if (editingId) {
      firebase.database().ref(`/projects/${uid}/${editingId}`).update(data)
        .then( () => {
          if (data.current_phase) {
            this.setState({
              editingPhase: this.state.editingPhase + 1,
              currentPhase: this.state.editingPhase + 1 < this.state.currentPhase 
                ? this.state.currentPhase
                : this.state.editingPhase + 1
            })
          } else if (submitting) {
            message.success(t('You have submitted the project!'))
            this.setState({
              editingPhase: null,
              currentPhase: null,
              editingProject: false,
              editingId: ""
            })
          }
        })
    }
  }

  getForm = () => {
    const { editingPhase, currentPhase, editingId } = this.state
    let component;
    switch (editingPhase) {
      case 1:
        component =
          <Investigation
            data={this.props.projects[this.state.editingId] && this.props.projects[this.state.editingId].Investigation}
            saveData={this.saveData}
            projectCompleted={currentPhase == 6}
            color={this.state.color}
            t={this.props.t}
            icon={this.getIcon()}
            currentPhase={currentPhase}
            uid={this.props.uid}
            editingId={this.state.editingId}
            title={this.props.projects[this.state.editingId] && this.props.projects[this.state.editingId].projectTitle}
            firebase={this.props.firebase}
          />
        break;
      case 2:
        component =
          <Preparation
            data={this.props.projects[this.state.editingId] && this.props.projects[this.state.editingId].Preparation}
            saveData={this.saveData}
            projectCompleted={currentPhase == 6}
            disabled={currentPhase < 2}
            color={this.state.color}
            t={this.props.t}
            icon={this.getIcon()}
            currentPhase={currentPhase}
          />
        break;
      case 3:
        component =
          <Action
            data={this.props.projects[this.state.editingId] && this.props.projects[this.state.editingId].Action}
            saveData={this.saveData}
            addActivity={this.addActivity}
            projectCompleted={currentPhase == 6}
            disabled={currentPhase < 3}
            color={this.state.color}
            t={this.props.t}
            icon={this.getIcon()}
            deleteFile={this.deleteFile}
            currentPhase={currentPhase}
          />
          break;
      case 4:
        component =
          <Reflection
            data={this.props.projects[this.state.editingId] && this.props.projects[this.state.editingId].Reflection}
            saveData={this.saveData}
            feeling={this.props.projects[this.state.editingId] && this.props.projects[this.state.editingId].feeling}
            disabled={currentPhase < 4}
            projectCompleted={currentPhase == 6}
            color={this.state.color}
            icon={this.getIcon()}
            t={this.props.t}
            firebase={this.props.firebase}
            uid={this.props.uid}
            editingId={this.state.editingId}
            show_popup={this.props.projects[this.state.editingId] && this.props.projects[this.state.editingId].show_popup}
            currentPhase={currentPhase}
          />
          break;
      case 5:
        component =
          <Demonstration
            data={this.props.projects[this.state.editingId] && this.props.projects[this.state.editingId].Demonstration}
            saveData={this.saveData}
            disabled={currentPhase < 4}
            projectCompleted={currentPhase == 6}
            color={this.state.color}
            icon={this.getIcon()}
            t={this.props.t}
            firebase={this.props.firebase}
            uid={this.props.uid}
            editingId={this.state.editingId}
            currentPhase={currentPhase}
          />
        break;
    }
    if (editingPhase) {
      return (
        <div>
          {component}
        </div>
      )
    } else {
      return null
    }
  }

  addActivity = (activity, editingActivity) => {
    return new Promise( (resolve, reject) => {
      const { editingId } = this.state
      const { uid } = this.props
      let downloadURLs = []
      const uploads = []
      this.props.firebase.database().ref(`/projects/${uid}/${editingId}/Action/`).update({ is_complete: true })
      activity.uploads.map(file => {
        uploads.push(this.props.firebase.uploadFile(`/projects/${uid}/${editingId}/Activuty`, file)
          .then(snapshot => {
            downloadURLs.push({ url: snapshot.uploadTaskSnaphot.metadata.downloadURLs[0], name: file.name })
          }))
      })
      Promise.all(uploads)
        .then(() => {
          let action = {
            notes: activity.notes,
            title: activity.activity,
            downloadURL: downloadURLs
          }
          if (editingActivity) {
            this.props.firebase.database().ref(`/projects/${uid}/${editingId}/Action/actionObject/${editingActivity}`).update(action)
              .then(() => resolve())
          } else {
            this.props.firebase.database().ref(`/projects/${uid}/${editingId}/Action/actionObject`).push(action)
              .then(() => resolve())
          }
        })
    })
  }

  getIcon = () => {

    if (this.state.color == '#006588') {
      return infoBlue
    } else if (this.state.color == '#7c868d') {
      return infoGray
    } else {
      return infoPink
    }
  }

  export = projectId => {
    this.setState({toExport: projectId},
    () => {
      this.layout.toExport.save(() => {
        this.setState({toExport: false})
      })
    })
  }

  render() {
    const { t, canSwitch, products, isSelfSignUp } = this.props
    const styles = {

      background: {
        backgroundImage: `url(${this.state.background})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        minHeight: '100vh',
        minWidth: '100vw',
        position: 'fixed'
      },
      addBtn: {
        fontSize: 50,
        fontFamily: 'Times new roman',
        color: 'white',
        backgroundColor: this.state.color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 60,
        width: 60,
        borderRadius: '50%',
        cursor: 'pointer',
        position: 'fixed',
        right: 25,
        bottom: 25,
        zIndex: 99
      },
      exportBtn: {
        height: 60,
        width: 60,
        borderRadius: '50%',
        cursor: 'pointer',
        position: 'fixed',
        left: 25,
        bottom: 25,
        zIndex: 99,
        backgroundColor: this.state.color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      },
      header: {
        backgroundColor: this.state.color,
        height: 77,
        marginBottom: 40,
        position: 'fixed',
        width: '100%',
        zIndex: 2,
        opacity: 0.95
      },
      gallery: {
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        paddingTop: 130,
        zIndex:99
      },
      closeicon: {
        position: 'absolute',
        right: 20,
        top: 20,
        color: 'white',
        fontSize: 50,
        opacity: 0.8,
        cursor: 'pointer',
        zIndex: 2
      },
      profileDiv: {
        position: 'absolute',
        right: 40,
        top: 5,
        height: 66,
        width: 66,
        overflow: 'hidden',
        borderRadius: '50%',
        cursor: 'pointer',
        boxShadow: 'rgb(0, 0, 0) 2px 3px 11px 0px'
      },
      button: {
        backgroundColor: this.state.color,
        color: 'white',
        border: 'none',
        borderRadius: '20px',
        width: 120
      },
      startButton: {
        backgroundColor: this.state.color,
        color: 'white',
        border: 'none',
        borderRadius: '20px',
        width: 'auto',
        margin: '0 auto',
        display: 'block'
      },
      pageNum: {
        width: 'max-content',
        padding: '6px 20px 0px 20px',
        backgroundColor: this.state.color,
        borderRadius: 20,
        color: 'white',
        fontSize: 14,
      },
      title: {
        fontSize: 21,
        marginLeft: -30,
        marginTop: 6,
        color: 'white',
        width: 'max-content',
        display: 'inline-block'
      },
      welcome: {
        fontSize: 24,
        marginTop: 40,
        marginBottom: 40,
        color: this.state.color,
        textAlign: 'center',
        fontFamily: 'Arial Rounded MT Bold'
      },
      product: {
        position: 'absolute',
        right: 128,
        top: 23,
        width: 30
      },
      welcome: {
        fontSize: 24,
        marginTop: 40,
        marginBottom: 40,
        color: this.state.color,
        textAlign: 'center',
        fontFamily: 'Arial Rounded MT Bold'
      },
      startButton: {
        backgroundColor: this.state.color,
        color: 'white',
        border: 'none',
        borderRadius: '20px',
        width: 'auto',
        margin: '0 auto',
        display: 'block'
      },
    }

    const numberProjects = this.state.projects.length
    let projects = []
    if (this.props.projects) {
      projects = Object.entries(this.props.projects).reverse()
    }

    const productBox = (
      <Row style={{width: 200}}>
        <Col
          className='productBox'
          xs={12}
          style={{cursor: (products && products.includes('SkillTracker')) ? 'pointer' : 'disabled'}}
          onClick={() => (products && products.includes('SkillTracker')) && !isSelfSignUp ? this.props.switchProduct('SkillTracker') : this.setState({unavailablePopup: isSelfSignUp ? 'coming_soon' : true})}
        >
          <img style={{width: 40, display: 'block', margin: '0 auto', marginTop: 20, border: '1px solid white'}} src={Skilllogo} />
          <h3 style={{fontSize: 12, color: this.state.color, marginBottom: 0, marginTop: 10, textAlign: 'center', fontFamily: 'Arial Rounded MT Bold' }}>Skill</h3>
          <h3 style={{fontSize: 12, color: this.state.color, marginBottom: 10, textAlign: 'center', fontFamily: 'Arial Rounded MT Bold'}}>Tracker</h3>
        </Col>
        <Col
          className='productBox'
          xs={12}
        >
          <img style={{width: 40, display: 'block', margin: '0 auto', marginTop: 20, border: '1px solid white'}} src={Servicelogo} />
          <h3 style={{fontSize: 12, color: this.state.color, marginBottom: 0, marginTop: 10, textAlign: 'center', fontFamily: 'Arial Rounded MT Bold' }}>Service</h3>
          <h3 style={{fontSize: 12, color: this.state.color, marginBottom: 10, textAlign: 'center', fontFamily: 'Arial Rounded MT Bold'}}>Tracker</h3>
        </Col>
      </Row>
    )

    return (
      <div style={styles.background} id="studentApp">
        <div>
          <Header style={styles.header}>
            <div style={{width: 'max-content', cursor: 'pointer'}} onClick={() => this.setState({editingProject: "",currentPhase: null,editingPhase: null, editingId: ""})}>
              <img src={Servicelogo} style={{width: 50, marginRight: 40}} />
              <h1 className='noAvenir' style={styles.title} onClick={() => this.setState({badgesOpen: true, exportMode: false, selectedLogs: []})}>Service Tracker</h1>
            </div>
            <Popover content={productBox} placement="bottom">
              <img src={Switch} style={styles.product}/>
            </Popover>
            <div style={styles.profileDiv} onClick={() => this.setState({profileOpen: true,  exportMode: false, selectedLogs: []})}>
              <img style={{ width: '100%', height: 'auto' }} src={this.props.profile.profile.image || this.props.auth.photoURL || profileImage} />
            </div>
          </Header>
          {this.state.editingProject ?
            <div style={{height: '100vh', overflow: 'scroll', position: 'relative'}}>
              <ProjectHeader
                title={R.path(['projects', this.state.editingId, 'projectTitle'], this.props)}
                phase={phases[this.state.editingPhase - 1]}
                t={t}
                close={() => this.setState({editingProject: false})}
                changeEditing={(index) => this.setState({editingPhase: index})}
                status={{
                  current: this.state.currentPhase,
                  editing: this.state.editingPhase
                }}
              />
              {this.getForm()}
            </div>
          :
            <div>
              <div>
                <Tooltip title={t("Add new project")}>
                  <div onClick={() => this.setState({projectInfoModal: true})} id='addLog' style={styles.addBtn}>+</div>
                </Tooltip>
              </div>
              <Content style={{paddingTop: this.state.exportMode ? 177 : 100, height: '100vh', overflow: 'scroll'}}>
                <div style={{margin: '0 auto', maxWidth:1000 }}>
                  <Row>
                    {projects.length === 0 &&
                      <div style={{ marginTop: '10%' }}>
                        <img style={{ display: 'block', margin: '0 auto' }} src={this.getNoLogImg()} />
                        <h1 className='noAvenir' style={styles.welcome}>{t('Welcome! Ready to start a project?')}</h1>
                        <Button onClick={() => this.setState({ projectInfoModal: true })} style={styles.startButton}>{t("Let's get started!")}</Button>
                      </div>
                    }
                    {projects.map( project => (
                      <Col xs={12} style={{padding: 10}}>
                        <ProjectCard
                          data={project[1]}
                          t={this.props.t}
                          color={this.state.color}
                          edit={() => this.editProject(project[0])}
                          editTitle={() => this.editProjectTitle(project[0])}
                          export={() => this.export(project[0])}
                        />
                      </Col>
                    ))}
                    {this.state.projects.length>20 &&
                      <Col xs={24} style={{display:'inline-flex',justifyContent: 'space-between', padding: '10px 10px 20px 10px'}}>
                        <Button className={this.state.projectsDisplayedFrom < 9 && 'hidden'} style={styles.button} onClick={() => this.setState({logsDisplayedFrom: this.state.projectsDisplayedFrom-10})}>{t('Previous')}</Button>
                        <div style={styles.pageNum}>{this.pageInfo()}</div>
                        <Button className={this.state.projectsDisplayedFrom+10 > numberProjects && 'hidden'} style={styles.button} onClick={() => this.setState({logsDisplayedFrom: this.state.projectsDisplayedFrom+10})}>{t('Next')}</Button>
                      </Col>
                    }
                  </Row>
                </div>
              </Content>
              <ProjectInfoModal
                t={t}
                color={this.state.color}
                open={this.state.projectInfoModal}
                close={() => this.setState({projectInfoModal: false})}
                addProject={this.addProject}
              />
            </div>
        }
        <StudentProfile
          product='Service'
          color={this.state.color}
          open={this.state.profileOpen}
          close={() => this.setState({profileOpen: false})}
          data={this.props.profile.profile}
          image={this.props.profile.profile.image || this.props.auth.photoURL || profileImage}
          uid={this.props.auth.uid}
          changeTheme={this.changeTheme}
        />
        {this.state.toExport &&
        <PDFLayout
          profile={this.props.profile}
          ref={(r) => this.layout = r}
          data={this.props.projects[this.state.toExport]}
        />
      }
        </div>
        <UnavailablePopup
          open={this.state.unavailablePopup}
          close={() => this.setState({unavailablePopup: false})}
          color={this.state.color}
          isComingSoon={this.state.unavailablePopup === 'coming_soon'}
        />
      </div>
    )
  }
}

const enhancer = compose(
  translate(['view', 'nav'], { wait: true }),
  firebaseConnect((props, store) => {
    const state = store.getState()
    const uid = R.path(['firebase','auth','uid'], state)
    return ['profile', `/projects/${uid}`];
  }),
  connect(
    state => {
      const uid = R.path(['firebase','auth','uid'], state)
      return {
        auth: state.firebase && state.firebase.auth,
        profile: state.firebase.profile || {},
        subjects: state.firebase.data.subjects || {},
        projects: state.firebase.data.projects && state.firebase.data.projects[uid] || {},
        uid
      }
    }
  )
)
export default withRouter(enhancer(Service))

const phases = ['Investigation', 'Preparation', 'Action', 'Reflection', 'Demonstration']

const newProjectObj = {
  "Action" : {
  "is_complete" : false,
  },
  "Demonstration" : {
    "description" : "",
    "documents" : [],
    "is_complete" : false,
    "notes" : ""
  },
  "Investigation" : {
    "completedDate" : "",
    "desiredImpact" : "",
    "identifyAndNeed" : "",
    "is_complete" : false,
    "learnerProfileAttribute" : [ ],
    "notes" : "",
    "projectType" : "",
    "relevantServiceLearningOutcomes" : [],
    "title" : ""
  },
  "Preparation" : {
    "expectedCompletionDate" : "",
    "how" : "",
    "is_complete" : false,
    "notes" : "",
    "when" : "",
    "where" : "",
    "who" : ""
  },
  "Reflection" : {
    "ATLCategories" : [],
    "actualImpact" : "",
    "is_complete" : false,
    "learnerProfileAttribute" : [],
    "learningOutcomes" : [],
    "notes" : "",
    "uploadEvidence" : [],
    "writeReflection" : ""
  },
  "createdAt" : moment().unix(),
  "feeling" : "",
  "show_popup" : true,
  "startDate" : moment().unix(),
  "status" : "inprogress",
  "current_phase" : "Investigation"
}



// WEBPACK FOOTER //
// ./src/containers/StudentApp/Service.jsx